import * as React from "react";
import styles from "./styles.scss";
// import variables from "styles/variables";

export interface Props {
  children: React.ReactNode;
}

export default function FadeIn({ children }: Props) {
  // const duration = Number(variables.transitionDuration.slice(0, -2));

  return <div className={styles.container}>{children}</div>;
  // @ts-ignore: Update to newer version
  // <CSSTransitionGroup
  //   className={styles.container}
  //   transitionName={styles}
  //   transitionEnterTimeout={duration}
  //   transitionLeaveTimeout={duration}
  // >
  //   {children}
  // </CSSTransitionGroup>
}
